import type { Label, Node } from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function getLabels(workspaceId: string) {
	const response = await axios.get<Label[]>(`${env.apiUrl}/nodes/${workspaceId}/labels`)

	return response.data
}

export async function getLabelNodes(workspaceId: string, label: string) {
	const response = await axios.get<Node[]>(`${env.apiUrl}/nodes/${workspaceId}/${label}`)

	return response.data
}

export async function getNodes(nodeIds: string[]) {
	const response = await axios.post<Node[]>(`${env.apiUrl}/nodes`, { nodeIds })

	return response.data
}

export async function getNodesConflicts(workspaceId: string, nodes: Node[]) {
	const response = await axios.post<Node[]>(`${env.apiUrl}/nodes/conflicts/${workspaceId}`, { nodes })

	return response.data
}

export async function getNode(nodeId: string) {
	const response = await axios.get<Node>(`${env.apiUrl}/nodes/${nodeId}`)

	return response.data
}

export async function createNode(workspaceId: string, node: Partial<Node>) {
	const response = await axios.post<Node>(`${env.apiUrl}/nodes/${workspaceId}`, { node })

	return response.data
}

export async function searchNode(name: string) {
	const response = await axios.post<{ nodes: Node[]; labels: Label[] }>(`${env.apiUrl}/nodes/search`, {
		name
	})

	return response.data
}

export async function updateNode(id: string, node: Partial<Node>) {
	await axios.put(`${env.apiUrl}/nodes/${id}`, node)
}

export async function getNodesDeletionPreview(nodeIds: string[]) {
	const response = await axios.post<{ relationshipCount: number }>(`${env.apiUrl}/nodes/deletion-preview`, {
		nodeIds
	})

	return response.data
}

export async function deleteNode(id: string) {
	await axios.delete(`${env.apiUrl}/nodes/${id}`)
}

export async function deleteNodeProperty(id: string, property: string) {
	await axios.delete(`${env.apiUrl}/nodes/${property}/${id}`)
}
